import React from "react";
import "./Brakingnews.css";

function Brakingnews() {
  return (
    <div>
      <div className="breaking_news">
        <div className="label ripple">Breaking News</div>
      </div>
    </div>
  );
}

export default Brakingnews;
